const quoteVideoBlock = {
    init() {
        const button = document.querySelector('.js-quote-video-play-button');
        const video = document.querySelectorAll('.js-quote-video > iframe');

        if (button && video) {
            button.addEventListener('click', (e) => {
                e.preventDefault();
                let hasParams = video[0].src.indexOf('?') > -1 ? '&' : '?';
                video[0].setAttribute('src', video[0].getAttribute('src') + hasParams + 'autoplay=1');
                button.classList.add('quote-video__video-wrapper__play-button--hidden');
            });
        }
    }
}

export default quoteVideoBlock;
